<!-- eslint-disable -->
<template lang="pug">
    div
        .form__title
            slot(name='title')
        form.form__body(action='javascript://' v-if='params')
            .form__field(v-if="gameMode !== 'course' && gameMode !== 'generator-settings'")
                label.form__label
                    | {{ $i18n.t('trainer.trainer_gameFormSetting_numOfExamples') }}
                .form__field-body.form-container__select-examples
                    cs-spin-input(
                        :value="params.amountOfExamples",
                        :max="amountOfExamples",
                        :min="1",
                        :disabled="params && (params.infinityAmountOfExamples || !!params.timeLimit)",
                        @increase="increaseExamples",
                        @decrease="decreaseExamples",
                        @input="params.amountOfExamples = $event",
                    )
                    .form-container__select-infinity-mode(v-if="gameMode && gameMode === 'free-game'")
                        cs-checkbox#infinityAmountOfExamples.form-container__checkbox(
                            v-model="params.infinityAmountOfExamples"
                            :checked="params && params.infinityAmountOfExamples"
                            :disabled="!!(params && (!!params.dictation || params.timeLimit))"
                        )
                        svg-icon.form-container__svg-icon(name="infinity" :aria-hidden="true" size="big")
            .form__field(v-if="gameMode !== 'course' && gameMode !== 'generator-settings'")
                label.form__label
                    | {{ $i18n.t('trainer.trainer_gameFormSetting_difficultyLevel') }}
                .form__field-body
                    cs-multiselect(
                        :show-labels="false"
                        :close-on-select="false"
                        :clear-on-select="false"
                        :allow-empty="false"
                        :hide-selected="true"
                        v-model="params.selectedClass"
                        :options="classes"
                        track-by="value"
                        placeholder=""
                        label="name"
                        :multiple="true"
                        :searchable="false"
                    )
            .form__field(v-if="gameMode !== 'course' && gameMode !== 'generator-settings'")
                label.form__label
                    | {{ $i18n.t('trainer.trainer_gameFormSetting_chooseElements') }}
                .form__field-body
                    cs-multiselect(
                        :show-labels="false"
                        :close-on-select="false"
                        :clear-on-select="false"
                        :allow-empty="false"
                        :hide-selected="true"
                        v-model="params.selectedParts"
                        :options="parts"
                        track-by="value"
                        placeholder=""
                        label="name"
                        :multiple="true"
                        :searchable="false"
                    )
            .form__field(v-if="gameMode !== 'course' && gameMode !== 'generator-settings'")
                label.form__label
                    | {{ $i18n.t('trainer.trainer_gameFormSetting_timeLimit') }}
                .form__field-body
                    cs-multiselect(
                        v-model="selectedTimeLimit",
                        @select="timeLimitHandler"
                        :disabled="params.dictation",
                        :options="formattedTimeLimitValues",
                        :show-labels="false",
                        :allow-empty="false",
                        label="label",
                        track-by="amount",
                        :multiple="false",
                        :hide-selected="false",
                        :placeholder="$i18n.t('trainer.trainer_gameFormSetting_noSpecified')",
                        :searchable="false",
                    )
            .form__field.checkbox(v-if="gameMode === 'free-game'")
                label.form__label.checkbox__label
                    |  {{  $i18n.t('trainer.trainer_gameFormSetting_dictation')  }}
                .form__field-body
                    cs-checkbox(v-model="params.dictation", @change="dictationClicked")
            .form__field(v-if='params.dictation')
                label.form__label
                    | {{ $i18n.t('trainer.trainer_gameFormSetting_timeToAnswer') }}
                .form__field-body
                    cs-multiselect(
                        v-model='selectedTimeForAnswer',
                        :options="dictationSeconds",
                        @select="timeForAnswerHandler",
                        track-by="time",
                        label="label",
                        :multiple="false",
                        :allow-empty="false",
                        :show-labels="false",
                        :placeholder="$i18n.t('trainer.trainer_gameFormSetting_select')",
                        :searchable="false",
                    )
            divider
            slot(name='parameters')
            slot(name='help')
            .form__buttons(v-if='!usersIds')
                cs-button.form__button(@click='cancel', color="blue", pattern="primary-outline")
                    | {{ $i18n.t('trainer.trainer_gameFormSetting_dontSave') }}
                template(v-if="gameMode === 'free-game'")
                    cs-button.form__button(color="blue", @click='saveGameMode')
                        | {{ $i18n.t('trainer.trainer_gameFormSetting_saveGame') }}
                template(v-else='')
                    cs-button.form__button(color="blue", @click='saveGame')
                        | {{ $i18n.t('trainer.trainer_gameFormSetting_saveGame') }}
            .form__buttons(v-else='')
                cs-button.form__button(@click='cancel', color="blue", pattern="primary-outline")
                    | {{ $i18n.t('trainer.trainer_gameFormSetting_dontSave') }}
                cs-button.form__button(color="blue", @click='saveGame')
                    | {{ $i18n.t('trainer.trainer_gameFormSetting_saveDifference') }}
</template>

<script>
/*eslint-disable*/
import GameFormMixin from "../../../utils/trainer/GameFormMixin";
import TrainerGames from '../../../config/trainer';
import { getInitParameters } from "@/utils/trainer/getInitParameters";
import { mapState } from 'vuex';
import _, {find} from "lodash";
import multiplayerFormMixin from "../../../utils/multiplayer/formMixin";
import IntervalConfig from "@/components/trainer/configs/IntervalConfig";

const DEFAULT_TIME_LIMIT = 0;

export default {
    props: [
        'slug',
        'courseType',
        'id',
        'usersIds',
        'homeworkId',
        'gameMode',
        'levelAnswerDuration',
        'gameId',
        'generatorSettings',
        'generatorGameIndex'
    ],
    mixins: [GameFormMixin, multiplayerFormMixin],
    data () {
        return {
            amountOfExamples: 100,
            timeLimitValues: IntervalConfig.secondsForDivideItRight,
            selectedTimeForAnswer: null,
            selectedTimeLimit: null,
            classes: [
                {
                    name: this.$i18n.t('trainer.trainer_gameFormSetting_wordStructure_1'),
                    value: '1',
                },
                {
                    name: this.$i18n.t('trainer.trainer_gameFormSetting_wordStructure_2'),
                    value: '2',
                },
                {
                    name: this.$i18n.t('trainer.trainer_gameFormSetting_wordStructure_3'),
                    value: '3',
                },
            ],
            parts: [
                {
                    name: this.$i18n.t('trainer.trainer_gameFormSetting_prefix'),
                    value: 'prefix',
                },
                {
                    name: this.$i18n.t('trainer.trainer_gameFormSetting_root'),
                    value: 'root',
                },
                {
                    name: this.$i18n.t('trainer.trainer_gameFormSetting_suffix'),
                    value: 'suffix',
                },
                {
                    name: this.$i18n.t('trainer.trainer_gameFormSetting_ending'),
                    value: 'ending',
                },
                {
                    name: this.$i18n.t('trainer.trainer_gameFormSetting_core'),
                    value: 'core',
                }
            ],
            dictationSeconds: [...Array(101).keys()].slice(1).map(time => {
                return {
                    time: time,
                    label: `${time} ` + this.$i18n.t('trainer.trainer_gameFormSettingValue_seconds'),
                };
            }),
            params: null,
            rows: 20,
        }
    },
    mounted () {
        if (this.gameMode === 'free-game') {
            let paramsArray = this.$store.state.trainer.paramsArray;
            if (paramsArray && paramsArray[0] && paramsArray[0].slug === this.slug) {
                this.paramsArray = _.cloneDeep(paramsArray);
                this.$emit('playersNumber', this.paramsArray.length);
                this.params = this.paramsArray[0];
            } else if (this.gamesParameters) {
                this.$set(this, 'params', getInitParameters({
                    slug: this.slug,
                    parameters: {
                        default: _.cloneDeep(this.gamesParameters[this.slug])
                    }
                }));
            } else {
                this.params = _.cloneDeep(TrainerGames.games).find(item => item.slug === this.slug).parameters.default;
            }
        } else {
            this.setInitParams(this.getKey(this.usersIds));
        }
        if (this.gameMode !== 'free-game') {
            this.params.dictation = false;
            this.params.infinityAmountOfExamples = false;
        }
        this.selectedTimeLimit = this.formattedTimeLimitValues.find(
            value => value.amount === this.params.timeLimit
        );
    },
    updated() {
        this.selectedTimeLimit = this.formattedTimeLimitValues.find(
            value => value.amount === this.params.timeLimit
        );
    },
    watch: {
        'params.dictation'(val) {
            if (val) {
                this.params.infinityAmountOfExamples = false;
                this.params.timeLimit = DEFAULT_TIME_LIMIT;
            }
        },
        'params.timeLimit'(val) {
            if (val) {
                this.params.infinityAmountOfExamples = true;
            } else {
                if (!this.params.amountOfExamples) {
                    this.params.amountOfExamples = 1;
                }
                this.params.infinityAmountOfExamples = false;
            }
            if (val === null) {
                this.params.timeLimit = 0;
            }
        },
    },
    methods: {
        timeLimitHandler(value) {
            this.params.timeLimit = value.amount;
        },
        timeForAnswerHandler(value) {
            this.params.timeForAnswer = value.time;
        },
        dictationClicked() {
            this.params.timeForAnswer = this.params.dictation ? 1 : '1';
        },
        timeLimitLabel(amount) {
            return amount === 0
                ? this.$i18n.t('trainer.trainer_gameFormSettingValue_off')
                : amount + ' ' + this.$i18n.t('trainer.trainer_gameFormSettingValue_minutes');
        },
        decreaseExamples() {
            if (
                this.params.amountOfExamples !== 1 &&
                !this.params.timeLimit &&
                !this.params.infinityAmountOfExamples
            ) {
                this.params.amountOfExamples -= 1;
            }
        },
        increaseExamples() {
            if (
                this.params.amountOfExamples !== this.amountOfExamples &&
                !this.params.timeLimit &&
                !this.params.infinityAmountOfExamples
            ) {
                this.params.amountOfExamples += 1;
            }
        },
    },
    computed: {
        ...mapState({
            homework: state => state.trainer.homework,
            gamesParameters: state => state.trainer.gamesParameters,
            user: state => state.auth.user
        }),
        formattedTimeLimitValues() {
            return this.timeLimitValues.map(amount => {
                return {
                    amount: amount,
                    label: amount
                        ? `${amount} ` + this.$i18n.t('trainer.trainer_gameFormSettingValue_minutes')
                        : this.$i18n.t('trainer.trainer_gameFormSettingValue_off'),
                };
            });
        },
        currentCourseType() {
            if (this.courseType) return this.courseType;
            if (this.$route.params.coursesType) return this.$route.params.coursesType;
            if (this.homework?.games[this.$route.params.gameId].courseType)
                return _.camelCase(this.homework.games[this.$route.params.gameId].courseType);
            return null;
        },
    },
}
</script>

<style lang="scss" scoped>
.form__title {
    font-weight: 500;
    font-size: 22px;
    line-height: 26px;
    text-align: center;
    margin-bottom: 25px;
}

.form__body {
    width: 100%;
    box-sizing: border-box;
    @include media($lg) {
        padding: 0 4.5%;
    }
}

.form__field {
    display: flex;
    flex-direction: column;
    margin-bottom: 20px;
    @include media($md) {
        padding: 0 2.5px;
        flex-direction: row;
        align-items: center;
    }
    @include media($lg) {
        padding: 0 10%;
    }
    @include media($xlg) {
        padding: 0 13%;
    }
}
.form__label {
    min-width: 0;
    font-size: 16px;
    line-height: 19px;
    margin-right: 20px;
    margin-bottom: .5rem;
    @include media($md) {
        width: 8em;
        margin-bottom: 0;
        text-align: right;
    }
    @include media($xlg) {
        max-width: none;
        min-width: 13em;
    }
}

.form__field-body {
    flex-grow: 5;
}

.form__buttons {
    margin-top: 30px;
    display: flex;
    flex-direction: column;
    justify-content: center;
    @include media($md) {
        flex-direction: row;
    }
}

.form__button {
    margin: 10px 50px;
    @include media($md) {
        margin: 0 10px;
    }
}

.form-container__select-examples {
    display: flex;
    flex-direction: column;
    align-items: flex-start;
    @media screen and (min-width: 700px) {
        flex-direction: row;
        align-items: center;
    }
}

.form-container__select-infinity-mode {
    display: flex;
    align-items: center;
    margin-top: 20px;
    @media screen and (min-width: 700px) {
        margin-top: 0;
    }
}

.form-container__checkbox {
    margin-left: 30px;
}

.form-container__svg-icon {
    opacity: 0.7;
    margin: 0 10px 10px 0;
}
</style>

